<app-alert></app-alert>
<app-notification-container></app-notification-container>
<app-notification-banner></app-notification-banner>
<app-cloning-notification-banner></app-cloning-notification-banner>
<app-in-call-dialog></app-in-call-dialog>
<app-incoming-call-dialog></app-incoming-call-dialog>
<app-navbar class="d-none d-md-block"></app-navbar>
<app-mobile-navbar class="d-block d-sm-block d-md-none"></app-mobile-navbar>
<!-- <app-bug-report-overlay></app-bug-report-overlay> -->
<router-outlet></router-outlet>
